import { React, useState } from "react";
import ReactCrop from "react-image-crop";

import "./Popup.css"; // Import CSS file for styling
import "react-image-crop/dist/ReactCrop.css";
import { aspectFitRect } from "../Utils";

function CropRectSelectPopup(props) {
  //crop container rect
  const [cropContainerRect, setCropContainerRect] = useState({
    x: 0,
    y: 0,
    width: 512,
    height: 512,
  });

  //get container rect
  //where we want to display our crop image
  const getCropContainerRect = () => {
    //container rect
    //maxwidth, maxheight = 80%
    const containerRect = aspectFitRect(
      [
        0,
        0,
        window === undefined ? 512 : window.innerWidth * 0.8,
        window === undefined ? 512 : window.innerHeight * 0.8,
      ],
      [0, 0, props.pageDimension[0], props.pageDimension[1]],
    );
    //return
    return containerRect;
  };

  return (
    <div className="popup-overlay" onClick={props.onClose}>
      {/* Stop propagation so clicking inside the content doesn't close the popup */}
      <div
        className="popup-content text-center"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: `${cropContainerRect.width}px`,
          height: `${cropContainerRect.height}px`,
          maxHeight: "90%",
          maxWidth: "90%",
        }}
      >
        {/* Close button */}
        <button className="popup-close" onClick={props.onClose}>
          <img
            loading="lazy"
            src="./images/x-circle-fill.svg"
            alt="cross"
            style={{
              filter:
                "brightness(0) saturate(100%) invert(58%) sepia(67%) saturate(7342%) hue-rotate(341deg) brightness(112%) contrast(92%)",
            }}
          ></img>
        </button>

        {/* Done button */}
        <button className="popup-done" onClick={props.onClose}>
          <img
            loading="lazy"
            src="./images/tick.svg"
            alt="tick"
            style={{
              filter:
                "brightness(0) saturate(100%) invert(80%) sepia(94%) saturate(4414%) hue-rotate(53deg) brightness(100%) contrast(96%)",
            }}
          ></img>
        </button>

        {/* Rect crop */}
        <ReactCrop
          crop={{
            unit: "%", // Can be 'px' or '%'
            x: props.outputSettings.outputSettings.cropX,
            y: props.outputSettings.outputSettings.cropY,
            width: props.outputSettings.outputSettings.cropWidth,
            height: props.outputSettings.outputSettings.cropHeight,
          }}
          onChange={(c, cp) => {
            props.outputSettings.setOutputSettings({
              ...props.outputSettings.outputSettings,
              cropX: cp.x,
              cropY: cp.y,
              cropWidth: cp.width,
              cropHeight: cp.height,
            });
          }}
          minHeight={50}
          minWidth={50}
          style={{
            width: `${cropContainerRect.width}px`, //width 93% of main container
            height: `${cropContainerRect.height}px`, //width 93% of main container
          }}
        >
          {/* Image to select crop rect from */}
          <img
            loading="lazy"
            src={props.pageImage}
            alt="crop_rect_image"
            style={{
              width: `${cropContainerRect.width}px`, //width 93% of main container
              height: `${cropContainerRect.height}px`, //width 93% of main container
            }}
            onLoad={(e) => {
              //set crop rect
              const cropContainer = getCropContainerRect();
              //set
              setCropContainerRect({
                ...cropContainer,
                x: cropContainer[0],
                y: cropContainer[1],
                width: cropContainer[2],
                height: cropContainer[3],
              });
            }}
          />
        </ReactCrop>
      </div>
    </div>
  );
}

export default CropRectSelectPopup;
